// extracted by mini-css-extract-plugin
export default {"text":"TextWithSpacesShown_text__5GO6k","bullet":"TextWithSpacesShown_bullet__KmBdW"};